export default "__VITE_ASSET__DBZ4rOtA__"